import React from 'react'
import { Loading } from '../index'
import { Dialog } from 'primereact/dialog'

function LoadingBox({ message, title, showLoadingBox }) {
  // Vars

  // Hooks

  // Events

  // Helpers

  // Render
  return (
    <Dialog
      showHeader={false}
      closable={false}
      visible={showLoadingBox}
      closeOnEscape={false}
      onHide={() => {}}
    >
      {title ? (
        <div className={'title'}>
          <strong>{title}</strong>
        </div>
      ) : null}
      <div className="text-center" style={{ marginTop: 15, marginBottom: 15 }}>
        <Loading size={'md'} />
      </div>
      <div className={'message'}>{message}</div>
    </Dialog>
  )
}

export default LoadingBox
